/**
 * Local Storage 的 key 值
 */
export enum LocalStorage {
  /** 使用者最後使用的語系 */
  LOCALE = 'locale',
  /** 使用者資訊 */
  USER_PROFILE = 'userProfile',
  /** 使用者資訊 - 身份別 */
  USER_PROFILE_IDENTITY = 'identity',
  /** 企業帳號 - 登入者帳號 */
  CORPORATE_ACCOUNT = 'corporateAccount',
  /** Router 暫存資料 */
  ROUTER_DATA = 'routerData',
  /** 驗證碼讀取次數 */
  CAPTCHA_LOADED_COUNT = 'captchaErrorCount',
  /** 是否記住登入資訊 */
  IS_REMEMBER_LOGIN_INFO = 'isRememberLoginInfo',
  /** otp data */
  OTP_DATA = 'otpData',
  /** otp 上一步 */
  OTP_LAST_STEP = 'otpLastStep',
  /** otp 時間 */
  OTP_IS_EXPIRED = 'otpIsExpired',

  /** 後台 - 回饋項目建置資料 - 預覽前台畫面 */
  PREVIEW_DATA = 'previewData',
  /** 後台 - 企業方案設定 - 快取資料（下架） */
  CORPORATE_PROGRAM_CACHE_DATA = 'corporateProgramCacheData',
  /** 後台 - 會員尊享 - 快取資料（下架） */
  EXCLUSIVE_OFFER_CACHE_DATA = 'exclusiveOfferCacheData',
  /** 後台 - 列表搜尋資料 */
  SEARCH_FORM = 'searchForm',
  /** 後台 - 搜尋歷史紀錄 */
  HISTORY_SEARCH = 'historySearch'
}
